import { CONTENT_MAX_LENGTH } from './content-max-length.const';
import { TITLE_MAX_LENGTH } from './title-max-length.const';

/** Validierungs-Messages pro Feld und Fehler-Key für den Announcement-Editor. */
export const EDITOR_VALIDATION_MESSAGES: Record<string, Record<string, string>> = {
  title: {
    required: 'Titel ist ein Pflichtfeld.',
    maxlength: `Titel darf maximal ${TITLE_MAX_LENGTH} Zeichen lang sein.`,
  },
  dateRange: {
    required: 'Aktiver Zeitraum ist ein Pflichtfeld.',
  },
  content: {
    required: 'Fließtext ist ein Pflichtfeld.',
    maxlength: `Fließtext darf maximal ${CONTENT_MAX_LENGTH} Zeichen lang sein.`,
  },
  linkUrl: {
    required: 'Wenn ein Button angezeigt wird, ist Link-URL ein Pflichtfeld.',
    pattern: 'Bitte eine gültige URL eingeben (z.B. https://...).',
  },
};
